var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 200,
    viewBox: "0 0 300 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9007 113.496C74.6233 88.472 91.892 58.714 128.693 63.2273C159.908 67.0547 166.675 62.1197 180.113 55.0873C188.987 50.4453 202.869 42.2317 214.132 65.719C228.873 96.4597 194.302 144.658 163.426 159.441C133.901 173.578 83.8453 158.907 77.9007 113.496V113.496Z",
    fill: "#A9162A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4817 68.9805L91.0453 59.4168C91.3935 59.0686 91.3935 58.5041 91.0453 58.1558C90.6971 57.8076 90.1325 57.8076 89.7843 58.1558L80.2207 67.7195C79.8724 68.0677 79.8724 68.6322 80.2207 68.9805C80.5689 69.3287 81.1334 69.3287 81.4817 68.9805Z",
    fill: "#E1E4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4405 156.315L84.1225 150.632C84.3295 150.425 84.3296 150.09 84.1227 149.883C83.9158 149.676 83.5802 149.676 83.3733 149.883L77.6912 155.565C77.4842 155.772 77.4842 156.108 77.6911 156.315C77.898 156.522 78.2335 156.522 78.4405 156.315Z",
    fill: "#E1E4E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.441 129.873L213.759 135.555C213.552 135.762 213.552 136.098 213.759 136.305C213.966 136.512 214.301 136.511 214.508 136.305L220.19 130.622C220.397 130.415 220.397 130.08 220.19 129.873C219.983 129.666 219.648 129.666 219.441 129.873Z",
    fill: "#E1E4E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4172 62.133L85.1754 59.3748C85.5236 59.0266 85.5236 58.462 85.1754 58.1138C84.8272 57.7656 84.2626 57.7656 83.9144 58.1138L81.1562 60.872C80.808 61.2202 80.808 61.7848 81.1562 62.133C81.5044 62.4812 82.069 62.4812 82.4172 62.133Z",
    fill: "#E1E4E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9966 152.246L80.6352 150.607C80.8422 150.4 80.8423 150.065 80.6354 149.858C80.4284 149.651 80.0929 149.651 79.8859 149.858L78.2473 151.497C78.0404 151.704 78.0403 152.039 78.2472 152.246C78.4541 152.453 78.7897 152.453 78.9966 152.246Z",
    fill: "#E1E4E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.884 133.942L217.246 135.58C217.039 135.787 217.039 136.123 217.246 136.33C217.452 136.537 217.788 136.537 217.995 136.33L219.634 134.691C219.841 134.484 219.841 134.148 219.634 133.942C219.427 133.735 219.091 133.735 218.884 133.942Z",
    fill: "#E1E4E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.704 166.839C161.18 167.204 159.132 167.991 157.97 169.556C156.809 171.122 158.214 171.584 160.069 171.283C161.924 170.983 163.764 169.936 164.511 168.463C165.257 166.99 163.956 166.54 162.704 166.839V166.839ZM170.216 163.924C169.479 164.1 168.49 164.48 167.929 165.236C167.368 165.992 168.046 166.215 168.942 166.07C169.838 165.925 170.728 165.42 171.088 164.708C171.448 163.996 170.82 163.779 170.216 163.924ZM197.635 153.78C199.55 152.468 199.737 149.412 199.737 149.412C199.737 149.412 196.82 148.486 194.907 149.8C192.993 151.112 192.804 154.167 192.804 154.167C192.804 154.167 195.721 155.093 197.635 153.78Z",
    fill: "#E1E4E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.457 41.775C193.867 41.775 195.01 40.5506 195.01 39.0403C195.01 37.53 193.867 36.3057 192.457 36.3057C191.048 36.3057 189.905 37.53 189.905 39.0403C189.905 40.5506 191.048 41.775 192.457 41.775Z",
    fill: "#E1E4E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M228.192 112.516C228.998 112.516 229.651 111.536 229.651 110.328C229.651 109.119 228.998 108.14 228.192 108.14C227.386 108.14 226.733 109.119 226.733 110.328C226.733 111.536 227.386 112.516 228.192 112.516Z",
    fill: "#E1E4E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M120.258 111.628L136.299 127.83L171.308 92.4603",
    stroke: "white",
    strokeWidth: 15.315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.893 55.6243C151.465 58.3853 140.134 49.7777 140.134 49.7777C140.134 49.7777 145.717 36.6977 156.149 33.9443C166.577 31.1833 177.905 39.7837 177.905 39.7837C177.905 39.7837 172.321 52.8633 161.893 55.6243V55.6243Z",
    fill: "url(#paint0_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.382 82.052C231.246 85.2433 225.382 84.5707 225.382 84.5707C225.382 84.5707 224.607 78.7233 227.745 75.5337C230.881 72.3423 236.741 73.0133 236.741 73.0133C236.741 73.0133 237.518 78.8607 234.382 82.052Z",
    fill: "url(#paint1_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1094 105.952C69.0295 105.952 71.3967 108.482 71.3967 111.604C71.3967 114.725 69.0295 117.256 66.1094 117.256C63.1892 117.256 60.822 114.725 60.822 111.604C60.822 108.482 63.1892 105.952 66.1094 105.952Z",
    fill: "#E1E4E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0154 80.427C66.1231 80.427 67.0211 79.6107 67.0211 78.6037C67.0211 77.5967 66.1231 76.7803 65.0154 76.7803C63.9077 76.7803 63.0098 77.5967 63.0098 78.6037C63.0098 79.6107 63.9077 80.427 65.0154 80.427Z",
    fill: "#E1E4E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.794 54.902C118.909 54.902 120.623 53.1878 120.623 51.0733C120.623 48.9588 118.909 47.2447 116.794 47.2447C114.68 47.2447 112.966 48.9588 112.966 51.0733C112.966 53.1878 114.68 54.902 116.794 54.902Z",
    fill: "#E1E4E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.403 45.786H224.326C223.871 52.289 219.076 52.389 219.076 52.389C219.076 52.389 224.363 52.493 224.363 60.007C224.363 52.493 229.651 52.389 229.651 52.389C229.651 52.389 224.858 52.289 224.403 45.786V45.786Z",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 122.541,
    y1: 62.8413,
    x2: 213.26,
    y2: 17.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 221.871,
    y1: 92.9533,
    x2: 244.54,
    y2: 57.4176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/EmailVerified.ec024ae3ca00f644cca125a8afda1b80.svg";
export { ForwardRef as ReactComponent };